import React from "react";
import CustomDialog from "./CustomDialog";
import { Box, Typography } from "@mui/material";
import CustomButton from "./CustomButton";

interface ConfirmDialogProps {
  open: boolean;
  title?: React.ReactNode;
  message?: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Confirm",
  message = "Are you sure?",
  onClose,
  onConfirm,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <CustomButton label="Cancel" onClick={onClose} />
          <CustomButton
            label="Delete"
            onClick={() => {
              onConfirm();
            }}
            variant="contained"
            bgColor="#d32f2f"
            textColor="#fff"
          />
        </>
      }
    >
      <Box>
        <Typography>{message}</Typography>
      </Box>
    </CustomDialog>
  );
};

export default ConfirmDialog;
